import { useCallback, useContext, useMemo } from 'react';

import { MapContext } from '../../../contexts/MapContext';
import useAnchorData from '../../../hooks/useAnchorData';
import NotesHeaderContainer from './components/NotesHeaderContainer';
import NotesSection from './components/NotesSection';
import NotesHeader from './components/NotesHeader';
import NotesListBase from './components/NotesList';
import useNotesForAnchor from './hooks/useNotesForAnchor';

// Displays the Notes for one LayerFeature.
const LayerFeatureNotesSubsection = ({ anchorId }) => {
  const { anchorName } = useAnchorData(anchorId);
  const notes = useNotesForAnchor(anchorId);

  if (notes.length === 0) return null;

  return (
    <>
      <NotesHeaderContainer>{anchorName}</NotesHeaderContainer>
      <NotesListBase notes={notes} />
    </>
  );
};

// Displays the Notes for all the LayerFeatures.
const LayerNotesList = ({ layerId }) => {
  const {
    layers: { layers },
  } = useContext(MapContext);

  const layerNotes = useNotesForAnchor(layerId);

  const layerFeatureRecordIds = useMemo(
    () => Object.keys(layers[layerId]?.layerFeatureRecords ?? {}),
    [layerId, layers],
  );

  return (
    <>
      {/* Layer Notes: */}
      <NotesListBase notes={layerNotes} />

      {/* LayerFeature Notes: */}
      {layerFeatureRecordIds.map((anchorId) => (
        <LayerFeatureNotesSubsection key={anchorId} anchorId={anchorId} />
      ))}
    </>
  );
};

const Header = () => <NotesHeader title="Layer Notes" />;

/**
 * Displays the Notes within a Layer.
 */
const LayerNotes = ({ layerId }) => {
  const NotesList = useCallback(() => <LayerNotesList layerId={layerId} />, [
    layerId,
  ]);

  return (
    <NotesSection
      anchorId={layerId} // <- used by the "+ New Note" button so that the new note is associated with this Layer
      Header={Header}
      NotesList={NotesList}
    />
  );
};

export default LayerNotes;
